var map = {
	"./bg-BG.json": 828,
	"./ca-ES.json": 829,
	"./cs-CZ.json": 830,
	"./de-DE.json": 831,
	"./el-GR.json": 832,
	"./en-US.json": 518,
	"./es-ES.json": 833,
	"./et-EE.json": 834,
	"./fi-FI.json": 835,
	"./fr-FR.json": 836,
	"./he-IL.json": 837,
	"./it-IT.json": 838,
	"./ja-JP.json": 839,
	"./ko-KR.json": 840,
	"./nb-NO.json": 841,
	"./nl-NL.json": 842,
	"./nn-NO.json": 843,
	"./pl-PL.json": 844,
	"./pt-BR.json": 845,
	"./ro-RO.json": 846,
	"./ru-RU.json": 847,
	"./sk-SK.json": 848,
	"./sv-SE.json": 849,
	"./tr-TR.json": 850,
	"./zh-CN.json": 851
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 827;